/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sign_OutInputs */

const th_sign_out = /** @type {(inputs: Sign_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ออกจากระบบ`)
};

const en_sign_out = /** @type {(inputs: Sign_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sign out`)
};

const ja_sign_out = /** @type {(inputs: Sign_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ログアウト`)
};

const zh_sign_out = /** @type {(inputs: Sign_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`登出`)
};

const es_sign_out = /** @type {(inputs: Sign_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cerrar sesión`)
};

const pt_sign_out = /** @type {(inputs: Sign_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sair`)
};

const id_sign_out = /** @type {(inputs: Sign_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keluar`)
};

const fr_sign_out = /** @type {(inputs: Sign_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Se déconnecter`)
};

const tl_sign_out = /** @type {(inputs: Sign_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mag-sign out`)
};

const vi_sign_out = /** @type {(inputs: Sign_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đăng xuất`)
};

const ko_sign_out = /** @type {(inputs: Sign_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`로그아웃`)
};

const de_sign_out = /** @type {(inputs: Sign_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abmelden`)
};

const ru_sign_out = /** @type {(inputs: Sign_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Выйти`)
};

const tr_sign_out = /** @type {(inputs: Sign_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Çıkış yap`)
};

const it_sign_out = /** @type {(inputs: Sign_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esci`)
};

const pl_sign_out = /** @type {(inputs: Sign_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wyloguj się`)
};

const uk_sign_out = /** @type {(inputs: Sign_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Вийти`)
};

const hi_sign_out = /** @type {(inputs: Sign_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`साइन आउट करें`)
};

const ar_sign_out = /** @type {(inputs: Sign_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تسجيل الخروج`)
};

const ms_sign_out = /** @type {(inputs: Sign_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Log keluar`)
};

const bn_sign_out = /** @type {(inputs: Sign_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`সাইন আউট`)
};

const zh_tw2_sign_out = /** @type {(inputs: Sign_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`登出`)
};

const zh_hk2_sign_out = /** @type {(inputs: Sign_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`登出`)
};

const ur_sign_out = /** @type {(inputs: Sign_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`سائن آؤٹ`)
};

const fa_sign_out = /** @type {(inputs: Sign_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`خروج`)
};

const sw_sign_out = /** @type {(inputs: Sign_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toka`)
};

const nl_sign_out = /** @type {(inputs: Sign_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uitloggen`)
};

/**
* | output |
* | --- |
* | "Sign out" |
*
* @param {Sign_OutInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const sign_out = /** @type {((inputs?: Sign_OutInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sign_OutInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_sign_out(inputs)
	if (locale === "ja") return ja_sign_out(inputs)
	if (locale === "zh") return zh_sign_out(inputs)
	if (locale === "es") return es_sign_out(inputs)
	if (locale === "pt") return pt_sign_out(inputs)
	if (locale === "id") return id_sign_out(inputs)
	if (locale === "fr") return fr_sign_out(inputs)
	if (locale === "tl") return tl_sign_out(inputs)
	if (locale === "vi") return vi_sign_out(inputs)
	if (locale === "ko") return ko_sign_out(inputs)
	if (locale === "de") return de_sign_out(inputs)
	if (locale === "ru") return ru_sign_out(inputs)
	if (locale === "tr") return tr_sign_out(inputs)
	if (locale === "it") return it_sign_out(inputs)
	if (locale === "pl") return pl_sign_out(inputs)
	if (locale === "uk") return uk_sign_out(inputs)
	if (locale === "hi") return hi_sign_out(inputs)
	if (locale === "ar") return ar_sign_out(inputs)
	if (locale === "ms") return ms_sign_out(inputs)
	if (locale === "bn") return bn_sign_out(inputs)
	if (locale === "zh-TW") return zh_tw2_sign_out(inputs)
	if (locale === "zh-HK") return zh_hk2_sign_out(inputs)
	if (locale === "ur") return ur_sign_out(inputs)
	if (locale === "fa") return fa_sign_out(inputs)
	if (locale === "sw") return sw_sign_out(inputs)
	if (locale === "nl") return nl_sign_out(inputs)
	return en_sign_out(inputs)
});